export interface RecommendedItem {
  id: string;
  name: string;
  /** Clave i18n para la descripción */
  descriptionKey?: string;
  image: string;
  url: string;
}

/**
 * Juegos recomendados para el carrusel superior (entre título y menú).
 * Si el array está vacío, la sección no se renderiza.
 */
export const recommendedGames: RecommendedItem[] = [
  {
    id: 'brainTwins',
    name: 'Brain Twins',
    descriptionKey: 'home.recommended.desc.brainTwins',
    image: 'images/games/braintwins.png',
    url: 'https://brain-twins.com',
  },
  // Agrega más juegos aquí
];

/**
 * Páginas recomendadas para el carrusel superior (entre título y menú).
 * Si el array está vacío, la sección no se renderiza.
 */
export const recommendedTools: RecommendedItem[] = [
  {
    id: 'imgParser',
    name: 'IMG Parser',
    descriptionKey: 'home.recommended.desc.imgParser',
    image: 'images/webs/imgparser.png',
    url: 'https://img-parser.com',
  },
  {
    id: 'dailyQuiz',
    name: 'Daily Quiz',
    descriptionKey: 'home.recommended.desc.dailyQuiz',
    image: 'images/webs/dailyquiz.png',
    url: 'https://daily-quiz.com',
  },
];
